import React from "react";
import "./shawnahuja.css";
import Myim1 from "../../myimgs/Logo_Png_Twoffers 2 1.png";
import logod from "../../myimgs/Group 13 (1).png";
import logodx from "../../myimgs/PRINT.png";
import grp6 from "../../myimgs/Group 12.png";
// import layer from "../../myimgs/Layer_1 (22).png"
const BusinessCard = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 lkio">
            <img src={Myim1} alt="" className="llol"/>

            <div className="vjiok">
              <img src={logodx} alt="" />
              <h2>
                SURINDER<br></br>
                (SHAWN) AHUJA
              </h2>
              <h5>Marketing Manager</h5>
            </div>

            <div className="contact-section">
              <div className="contact-item">
                <i className="fas fa-globe icon"></i>
                <div>
                  <h4>Website</h4>
                  <p>www.twoffers.com</p>
                </div>
              </div>

              <div className="contact-item">
                <i className="fas fa-building icon"></i>
                <div>
                  <h4>Twoffers</h4>
                  <p>Div. of 2022842 Ontario Inc.</p>
                </div>
              </div>

              <div className="contact-item">
                <i className="fas fa-phone icon"></i>
                <div>
                  <h4>Phone Number</h4>
                  <p>+1 (289 8011099)</p>
                </div>
              </div>

              <div className="contact-item">
                <i className="fas fa-map-marker-alt icon"></i>
                <div>
                  <h4>Address</h4>
                  <p>
                    6740 Davand Drive Unit 11, Mississauga,
                    <br />
                    Ontario L5T 2K9
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 logops">
            <img src={logod} alt="" className="logop" />
            <img src={grp6} alt="" className="kiok" />
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessCard;
